import React from "react";

import { Row, Col} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/HomePage/Statistics.css";

const itemMarginDesktop ={
    marginTop:"65px"
};
const numberDesktop ={
    fontFamily: "IRANSans", 
    color: "#fff", 
    fontSize: "3.5em"
}
const numberTablet = {
    fontFamily: "IRANSans",
    color: "#fff",
    fontSize: "2.8em"
}
const numberMobile = {
    fontFamily: "IRANSans",
    color: "#fff",
    fontSize: "2.5em"
}
const descriptionDesktop={
    fontFamily: "IRANSans",
     color: "#fff",
     marginTop:"-12.5px"
}
const descriptionTablet = {
    fontFamily: "IRANSans",
    color: "#fff",
    marginTop: "-12.5px",
    fontSize:"1.2em",
    textAlign:"center"
}
const descriptionMobile = {
    fontFamily: "IRANSans",
    color: "#fff",
    marginTop: "-12.5px",
    fontSize:"1em",
    textAlign:"center"
}
const Statistics = props => {

     return props.size === "laptopdesktop" ? (
            <div className="statisticsBackground">
                <Row>
                    <Col span={2}></Col>
                    <Col span={5} style={itemMarginDesktop}>
                       <Center>
                            <p style={numberDesktop}>۲۴</p>
                       </Center>
                       <Center>
                            <p style={descriptionDesktop}>پشتیبانی ۲۴ ساعته</p>
                       </Center>
                    </Col>
                    <Col span={5} style={itemMarginDesktop}>
                        <Center>
                            <p style={numberDesktop}>40</p>
                       </Center>
                       <Center>
                            <p style={descriptionDesktop}>شعبه در سراسر کشور</p>
                       </Center>
                    </Col>
                    <Col span={5} style={itemMarginDesktop}>
                        <Center>
                            <p style={numberDesktop}>3025</p>
                       </Center>
                       <Center>
                            <p style={descriptionDesktop}>کارشناس سیار</p>
                       </Center>
                    </Col>
                    <Col span={5} style={itemMarginDesktop}>
                        <Center>
                            <p style={numberDesktop}>12</p>
                       </Center>
                       <Center>
                            <p style={descriptionDesktop}>شرکت زیرمجموعه</p>
                       </Center>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>

     ) : props.size === "tablet" ? (
            <div className="statisticsBackground">
                <Row style={{paddingTop:"10px"}}>
                    <Col span={12}>
                        <Center>
                            <p style={numberTablet}>3025</p>
                       </Center>
                       <Center>
                             <p style={descriptionTablet}>کارشناس سیار</p>
                       </Center>
                    </Col>
                    <Col span={12}>
                        <Center>
                             <p style={numberTablet}>12</p>
                        </Center>
                        <Center>
                             <p style={descriptionTablet}>شرکت زیرمجموعه</p>
                        </Center>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Center>
                             <p style={numberTablet}>24</p>
                        </Center>
                        <Center>
                             <p style={descriptionTablet}>پشتیبانی ۲۴ ساعته</p>
                        </Center>
                    </Col>
                    <Col span={12}>
                        <Center>
                             <p style={numberTablet}>40</p>
                       </Center>
                       <Center>
                            <p style={descriptionTablet}>شعبه در سراسر کشور</p>
                       </Center>
                    </Col>
                </Row>
            </div>

     ) : (
            <div className="statisticsBackground">
                <Row style={{paddingTop:"10px"}}>
                    <Col span={12}>
                        <Center>
                            <p style={numberMobile}>3025</p>
                       </Center>
                       <Center>
                                 <p style={descriptionMobile}>کارشناس سیار</p>
                       </Center>
                    </Col>
                    <Col span={12}>
                        <Center>
                            <p style={numberMobile}>12</p>
                        </Center>
                        <Center>
                            <p style={descriptionMobile}>شرکت زیرمجموعه</p>
                        </Center>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Center>
                            <p style={numberMobile}>24</p>
                        </Center>
                        <Center>
                            <p style={descriptionMobile}>پشتیبانی ۲۴ ساعته</p>
                        </Center>
                    </Col>
                    <Col span={12}>
                        <Center>
                            <p style={numberMobile}>40</p>
                       </Center>
                       <Center>
                            <p style={descriptionMobile}>شعبه در سراسر کشور</p>
                       </Center>
                    </Col>
                </Row>
            </div>
          );
};

export default Statistics;
